export default __webpack_public_path__ + "static/media/cbbSala1.c57f7353.jpg";